import React, { Component } from "react";

class EventUpSVG extends React.Component {
  render() {
    return (
      <svg
        className={"svg-container " + this.props.svgClassName}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 24 24"
      >
        <path
          className="svg"
          d="M20.4,0.6h-8.9c-0.1,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h8.9c1.7,0,3.1,1.4,3.1,3.1c0,1.5-1.1,2.8-2.6,3
	c-0.1,0-0.2,0.2-0.2,0.3c0,0.1,0.1,0.2,0.3,0.2c1.7-0.3,3-1.8,3-3.5C24,2.2,22.4,0.6,20.4,0.6z M10.4,0.6h-0.2
	c-0.1,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h0.2c0.1,0,0.3-0.1,0.3-0.3S10.6,0.6,10.4,0.6z M13.8,23.4h-0.2c-0.1,0-0.3-0.1-0.3-0.3
	s0.1-0.3,0.3-0.3h0.2c0.1,0,0.3,0.1,0.3,0.3S13.9,23.4,13.8,23.4z M12.5,23.4H3.6c-2,0-3.6-1.6-3.6-3.6c0-1.7,1.2-3.2,3-3.5
	c0.1,0,0.3,0.1,0.3,0.2c0,0.1-0.1,0.3-0.2,0.3c-1.5,0.3-2.6,1.5-2.6,3c0,1.7,1.4,3.1,3.1,3.1h8.9c0.1,0,0.3,0.1,0.3,0.3
	S12.6,23.4,12.5,23.4z M4.2,2.9C4.6,2.9,5,3,5.3,3.1c0.9,0.2,1.7,0.6,2.4,1c1.1,0.7,2.3,1.3,3.4,2.1c0.6,0.5,1.1,0.9,1.7,1.3
	C13.3,8,13.9,8.4,14.4,9c0.1,0.1,0.2,0.1,0.2,0c0.6-0.6,1.1-1.1,1.7-1.7l0.1-0.1c-0.1-0.5,0.1-0.8,0.2-1.1c0.3-0.8,0.8-1.4,1.2-2
	c0.3-0.3,0.5-0.5,0.8-0.8C19,3,19.4,3,19.7,3.2c0.4,0.2,0.8,0.6,0.9,0.9c0.3,0.5,0.2,0.8-0.2,1.1c-0.7,0.9-1.5,1.5-2.6,1.9
	c-0.4,0.2-0.8,0.4-1.2,0.3c-0.1,0-0.2,0.1-0.2,0.2c-2.8,2.8-5.8,5.8-8.6,8.6c-0.2,0.2-0.3,0.3-0.5,0.5c0,0-0.1,0.1-0.1,0.2
	c0.1,0.3-0.1,0.6-0.2,0.9c-0.2,0.7-0.6,1.1-0.9,1.8C5.8,20,5.4,20.4,5,20.7C4.6,21,4.2,21,3.8,20.7c-0.3-0.2-0.6-0.5-0.8-0.9
	c-0.2-0.3-0.2-0.5-0.1-0.8c0.2-0.4,0.5-0.8,0.9-1c0.3-0.3,0.7-0.5,0.9-0.8c0.5-0.4,1-0.7,1.7-0.8c0.2,0,0.2-0.1,0.4-0.1
	c0.2,0.1,0.3-0.1,0.5-0.2c0.6-0.6,1.1-1.1,1.7-1.7c0.1-0.1,0.2-0.2,0-0.2c-0.8-0.8-1.5-1.6-2.1-2.5c-0.5-0.7-0.9-1.2-1.4-2
	C5.1,9.3,4.6,8.6,4.2,7.8c-0.5-0.8-0.8-1.5-1-2.2C3.1,5.2,2.9,4.7,2.9,4.2C2.9,3.3,3.4,2.9,4.2,2.9z M13,10.7
	c-0.4-0.2-0.7-0.5-1-0.8c-0.6-0.4-1.1-0.8-1.9-0.8C9.6,9,9.1,9.1,9.2,9.8c0,0.3,0.1,0.6,0.2,0.9c0.2,0.4,0.4,0.7,0.5,1
	c0.2,0.5,0.5,0.8,0.9,1.1C11.4,12.1,12.2,11.4,13,10.7z M13.8,11.6c0.3,0.5,0.6,0.9,0.9,1.5c0.2,0.2,0.2,0.5,0.4,0.8
	c0.1,0.2,0.1,0.5,0.1,0.7c0,0.3-0.3,0.6-0.6,0.6c-0.5-0.1-1-0.2-1.5-0.5c-0.5-0.3-0.9-0.6-1.4-0.9c-0.5,0.5-1,1-1.6,1.6v0.1
	c0.5,0.5,0.9,0.9,1.5,1.2c0.9,0.7,1.8,1.3,2.7,1.9c0.6,0.5,1.2,0.8,1.8,1.1c0.8,0.5,1.5,0.9,2.4,1.1c0.5,0.2,1,0.4,1.6,0.3
	c0.8,0,1-0.4,1.1-1.1c0-0.5-0.2-1-0.3-1.5c-0.3-0.9-0.7-1.7-1.1-2.5c-0.5-0.9-1-1.7-1.5-2.5c-0.4-0.6-0.8-1.1-1.2-1.7
	c-0.3-0.4-0.5-0.8-0.8-1c-0.3-0.2-0.5-0.7-0.8-0.9C14.9,10.6,14.3,11.1,13.8,11.6z"
        />
      </svg>
    );
  }
}

export default EventUpSVG;



// WEBPACK FOOTER //
// ./src/svg/EventUpSVG.jsx